import { HttpErrorResponse } from '@angular/common/http';
import { ISendInvitation } from '@app/modules/invitations/interface/invitation';

export namespace InvitationsActions {
  /**
   * @action GetAllInvitations
   */
  export class GetAllInvitations {
    static type = '[Invitations] GetAllInvitations';
  }
  export class GetAllInvitationsSuccess {
    static type = '[Invitations] GetAllInvitationsSuccess';
  }
  export class GetAllInvitationsFailed {
    static type = '[Invitations] GetAllInvitationsFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action SendInvitation
   */
  export class SendInvitation {
    static type = '[Invitations] SendInvitation';
    constructor(public model: ISendInvitation) {}
  }
  export class SendInvitationSuccess {
    static type = '[Invitations] SendInvitationSuccess';
    constructor(public model: ISendInvitation) {}
  }
  export class SendInvitationFailed {
    static type = '[Invitations] SendInvitationFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action AcceptInvitation
   */
  export class AcceptInvitation {
    static type = '[Invitations] AcceptInvitation';
    constructor(public invitationId: number) {}
  }
  export class AcceptInvitationSuccess {
    static type = '[Invitations] AcceptInvitationSuccess';
  }
  export class AcceptInvitationFailed {
    static type = '[Invitations] AcceptInvitationFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action DeclineInvitation
   */
  export class DeclineInvitation {
    static type = '[Invitations] DeclineInvitation';
    constructor(public invitationId: number) {}
  }
  export class DeclineInvitationSuccess {
    static type = '[Invitations] DeclineInvitationSuccess';
  }
  export class DeclineInvitationFailed {
    static type = '[Invitations] DeclineInvitationFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action CancelInvitation
   */
  export class CancelInvitation {
    static type = '[Invitations] CancelInvitation';
    constructor(public invitationId: number) {}
  }
  export class CancelInvitationSuccess {
    static type = '[Invitations] CancelInvitationSuccess';
  }
  export class CancelInvitationFailed {
    static type = '[Invitations] CancelInvitationFailed';
    constructor(public error?: HttpErrorResponse) {}
  }
}
